import * as a from '../actions/employee'
import { createReducer } from 'redux-act'

let DEFAULT_STATE = {
    employeeList: JSON.parse(window.localStorage.getItem('employeeList')) ||  {employeeListAccountingApproval:[], employeeListManagerApproval:[] },
    updateEmployeeResult: false
}
export default createReducer(
    {
        [a.getEmployeesSuccessful]: (state, payload) => {
            window.localStorage.setItem("employeeList", JSON.stringify(payload && payload.employees));
            return {
                ...state,
                employeeList: payload && payload.employees
            }
        },
        [a.getEmployeesFailure]: (state, payload) => {
            return {
                ...state
            }
        },
        [a.updateEmployeeSuccessful]: (state, payload) => {
            state.updateEmployeeResult = true;
            return {
                ...state
            }
        },
        [a.updateEmployeeFailure]: (state, payload) => {
            state.updateEmployeeResult = false;
            return {
                ...state
            }
        }
    },
    DEFAULT_STATE
);